import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DesignFtoApi, DesignFtoApiImpl, LocApi, LocApiImpl } from './apis'

export const designFtoContainer = new ContainerModule((bind) => {
    bind(LocApi).to(LocApiImpl);
    bind(DesignFtoApi).to(DesignFtoApiImpl);
})

export { default as DesignFtoSearchContainer } from './components/containers/DesignFtoSearchContainer.vue';
